export function getProjects(){
	return projects;
}

const projects = [
	{ tasks17:"54", tasks18:"78", project:"Testing" },
	{ tasks18:"54", tasks17:"34", project:"Management" },
	{ tasks17:"84", tasks18:"50", project:"Support" },
	{ tasks17:"34", tasks18:"53", project:"Data Quality" }
];
